import { defineComponent, ref } from "vue";

import { COMPONENT_NAME, SharedDateFormat, SVG } from "./attributes";

// import { getDate } from "@/shared/utils/moment-helpers";
import { Language, MomentFormat } from "@/shared/constants/enums";
import type { DatePickerInstance } from "@vuepic/vue-datepicker";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    view: {
      type: String,
      default: "",
    },
    range: {
      type: Boolean,
      default: false,
    },
    multiCalendars: {
      type: Boolean,
      default: false,
    },
    time: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: SharedDateFormat.date,
    },
    placeholder: {
      type: String,
      default: "",
    },
    enableTimePicker: {
      type: Boolean,
      default: false,
    },
    date: {
      type: [String, Array],
      default: "",
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    "update:date": null,
  },
  setup() {
    const datepicker = ref<DatePickerInstance | null>(null);
    return {
      datepicker,
    };
  },
  data() {
    return {
      isOpen: false,
      userRepo: this.$projectServices.userRepo,
    };
  },
  computed: {
    displayedIcon(): string {
      return SVG.icon;
    },

    displayedFormat(): MomentFormat | string {
      switch (this.format) {
        case SharedDateFormat.date:
          return MomentFormat.date;
        case SharedDateFormat.dateReverse:
          return MomentFormat.dateReverse;
        case "dd-MM-yyyy":
          return "DD-MM-YYYY";
        default:
          return MomentFormat.date;
      }
    },

    displayedLocale(): Language {
      return this.userRepo.userInfo.user_info.lang;
    },
  },
  methods: {
    changeDate(val: string | string[]): void {
      this.$emit("update:date", val);
      this.datepicker?.closeMenu();
    },

    clearDate(): void {
      this.$emit("update:date", this.range ? [] : "");
    },

    handleOpen(): void {
      this.isOpen = true;
    },

    handleClose(): void {
      this.isOpen = false;
    },
  },
});
